<template>
    <div class="page">
        <Header title="文章详情" />
        <div class="scrollerView" :style="{ height: wrapperHeight + 'px' }">
            <scroller :on-refresh="refresh" :noDataText="commentList.length > 1 ? Constants.ALL_LOAD_TIPS : ''" :on-infinite="infinite" ref="infinite" class="scroller">
                <div class="header">
                    <h3>{{ dataSources.name }}</h3>
                    <p class="time">{{ dataSources.create_time }}</p>
                    <div>
                        <div>
                            <img :src="Images.icon_read" alt="" />
                            <p>
                                <span>{{ dataSources.visits }}</span>
                                <span class="none">阅读</span>
                            </p>
                        </div>
                        <div>
                            <img :src="Images.icon_good" alt="" />
                            <p>
                                <span>{{ dataSources.likes }}</span>
                                <span class="none">点赞</span>
                            </p>
                        </div>
                        <div class="none" @click="scrollToComment">
                            <img :src="Images.icon_comment_blue" alt="" />
                            <p>
                                <span>{{ dataSources.comments }}</span>
                                <span class="none">评论</span>
                            </p>
                        </div>
                        <div>
                            <img :src="Images.icon_share_blue" alt="" />
                            <p>
                                <span>{{ dataSources.shares }}</span>
                                <span class="none">分享</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div v-html="dataSources.content"></div>
                </div>
                <!-- 代理商信息 -->
                <div class="agent-info-wrap" v-if="userInfo.is_agent > 0 && agentInfo.real_name">
                    <div class="user-info-wrap flex ccc">
                        <img :src="agentInfo.avatar || Images.img_avatar_default_pic" alt="" class="user-avatar-img" />
                        <p class="username">{{agentInfo.real_name || agentInfo.name}}</p>
                    </div>
                    <div class="company-info-wrap">
                        <div class="info-item flex rcs">
                            <img :src="Images.icon_arc_company" alt="" class="info-icon" />
                            <span class="info-value">{{agentInfo.agent_company}}</span>
                        </div>
                        <div class="info-item flex rcs">
                            <img :src="Images.icon_arc_mobile" alt="" class="info-icon" />
                            <span class="info-value">{{agentInfo.mobile}}</span>
                            <a :href="'tel:' + agentInfo.mobile" class="btn-item call-btn-item">电话联系</a>
                        </div>
                    </div>
                </div>
                <!-- 评论 -->
                <div class="comment-box">
                    <div class="tit" ref="commentTitle">
                        <span>评论列表</span>
                    </div>
                    <commentItem v-for="(item, index) in commentList" :key="index" :item="item" />
                    <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
                </div>
            </scroller>
        </div>
        <div class="footer-placeholder-wrap"></div>
        <div class="footer">
            <div class="btn" @click="onPressLike">
                <img :src="Images.icon_good" alt="" />
                <p v-if="dataSources.is_like">取消</p>
                <p v-else>点赞</p>
            </div>
            <div class="btn btn-cur" @click="_onPressToShare">
                <img :src="Images.icon_share" alt="" />
                <p>分享</p>
            </div>
            <div class="td-f1 td-fec none">
                <div class="input td-fsc" @click="showCommentInputModel">
                    <img :src="Images.icon_edit" />
                    <span>写留言</span>
                </div>
            </div>
        </div>
        <!-- 写评论 -->
        <comment-input @callback="commentCannback" :show="showCommentInput"></comment-input>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { wxSetup, wxShare } from '@/utils/wxShare'
import Header from "../../components/Header";
import CommentInput from "../../components/CommentInput";
import commentItem from "../../components/item/commentItem";
export default {
    components: {
        Header,
        CommentInput,
        commentItem,
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    data() {
        return {
            loading: false,
            wrapperHeight: 0,
            id: this.$route.query.id,
            uid: this.$route.query.uid,
            dataSources: {},
            // 评论
            showCommentInput: false,
            commentList: [],
            page: 0,
            limit: 10,
            agentInfo: {},
        };
    },
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
        this.requestData();
        setTimeout(() => {
            this._setupWechatConfig();
            this._onSetImgUrl();
        }, 500);
    },
    methods: {
        _onSetImgUrl() {
            // 获取所有 img 元素
            let imgs = document.querySelectorAll('img');

            // 定义域名
            const domain = 'https://wap.ys141319.com';

            // 遍历 img 元素
            imgs.forEach(img => {
                const src = img.getAttribute('src');
                // 判断 src 是否包含域名信息
                if (!src.startsWith('http://') && !src.startsWith('https://') && !src.startsWith('data:')) {
                    // 如果 src 是相对路径，添加域名
                    img.src = domain + src;
                }
            });
        },

        // 设置分享参数
        async _setupWechatConfig() {
            let url = this.API.wx_setup_info;
            let data = {
                page_flag: 'common',
                share_url: window.location.href.split('#')[0],
            };

            let _urlTemp = window.location.href;
            if (_urlTemp.indexOf('is_share=1&uid=') > -1) {
                _urlTemp = _urlTemp.split('is_share=1&uid=')[0] + 'is_share=1&uid=' + this.userInfo.id;
            } else {
                _urlTemp = _urlTemp + '&is_share=1&uid=' + this.userInfo.id;
            }

            console.log('this.userInfo, _urlTemp---->', this.userInfo, _urlTemp);

            // 非微信环境直接退出
            if (!this.$isWeiXin()) return;
            let result = await this.$post(url, data);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                let share_params = {
                    ...result.data.share_params,
                    title: this.dataSources.name,
                    desc: this.dataSources.desc,
                    icon: this.dataSources.cover,
                    link: _urlTemp,
                }
                wxShare(result.data.share_config, share_params, () => {});
            }
        },

        // 请求数据
        async requestData() {
            let url = this.API.article_detail;
            let params = {
                id: this.id,
                uid: this.uid,
                token: this.Lockr.get("token"),
            };
            let result = await this.$post(url, params);
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                that.dataSources = result.data.article_detail;
                that.agentInfo = result.data.agent_info || {};
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 获取评论
        refresh() {
            this.page = 1;
            this.requestDataComment();
            setTimeout(
                function() {
                    this.$refs.infinite.finishPullToRefresh();
                }.bind(this),
                1000
            );
        },
        infinite() {
            this.page++;
            setTimeout(() => {
                this.requestDataComment();
            }, 500);
        },
        async requestDataComment() {
            let url = this.API.article_comment_list;
            let params = {
                article_id: this.id,
                token: this.Lockr.get("token"),
                page: this.page,
                limit: this.limit,
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                let list = result.data.list || [];
                if (this.page == 1) {
                    this.commentList = list;
                } else {
                    this.commentList = this.commentList.concat(list);
                }
                this.$refs.infinite.finishInfinite(list.length < this.limit);
            } else {
                this.Message({
                    title: result.msg,
                    onClose: () => {
                        this.$router.go(-1)
                    }
                });
            }
        },
        // 点赞喜欢
        async onPressLike() {
            let url = this.API.home_page_like;
            let params = {
                token: this.Lockr.get("token"),
                id: this.id,
                type: "article", // article:文章信息 destiny:运势点赞
            };
            let result = await this.$post(url, params);
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                this.requestData();
                this.Message({
                    title: result.msg,
                });
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },

        // 点击分享
        async _onPressToShare() {
            this.$emit(this.Constants.SHOWSHAREPOPUP, true);

            let url = this.API.share_content;
            let params = {
                id: this.id,
                type: 0, // 0是文章，1是视频，2是音频，3是运势
            };
            let result = await this.$get(url, params);
        },
        showCommentInputModel() {
            this.showCommentInput = true;
        },
        commentCannback(res) {
            console.log("res", res);
            if (res.type == "cancel") {
                this.showCommentInput = false;
            } else if (res.type == "success") {
                this.submitComment(res.data);
            }
        },
        async submitComment(res) {
            let url = this.API.article_comment;
            let params = {
                article_id: this.id,
                token: this.Lockr.get("token"),
                comment: res.content,
                image: res.img_src,
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.Message({
                    title: result.msg,
                });
                this.showCommentInput = false;
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 滚动到评论
        scrollToComment() {
            let top = this.$refs.commentTitle.offsetTop;
            this.$refs.infinite.scrollTo(0, top, true);
        },

    },
};
</script>
<style lang="less" scoped>
.page {
    min-height: 100vh;
    background-color: #fff;
}

.scrollerView {
    width: 100%;
    position: relative;
    background-color: #fff;
}

.header {
    padding: 10px 0;
    margin: 0 15px;
    border-bottom: solid #eee 2px;

    h3 {
        font-size: 17px;
        font-weight: 500;
        color: #333;
        margin-bottom: 10px;
    }

    .time {
        font-size: 14px;
        color: #333;
        margin-bottom: 10px;
    }

    >div {
        display: flex;
        align-items: center;
        justify-content: space-between;

        >div {
            display: flex;
            align-items: center;

            img {
                width: 15px;
                height: 15px;
                margin-right: 5px;
            }

            p {
                font-size: 13px;
                color: #333;
            }
        }

        >p {
            font-size: 13px;
            color: #666;
            flex: 1;
            text-align: right;
        }
    }
}

.content {
    font-size: 14px;
    color: #333;
    line-height: 2;
    padding: 15px 15px 100px;

    /deep/ img {
        max-width: 100%;
    }
}

.agent-info-wrap {
    margin: 1.5rem;
    padding: 1rem 1.5rem;
    border-radius: .5rem;
    // box-shadow: 0px 0px 5px #dfdfdf;
    background-size: 100% 100%;
    background-image: url('../../assets/img/img_bg_arc_agent.png');

    .user-info-wrap {
        width: 50%;

        .user-avatar-img {
            width: 5rem;
            height: 5rem;
            margin-bottom: 1rem;
        }

        .username {
            font-size: 1.4rem;
            font-weight: 600;
        }
    }

    .company-info-wrap {

        .info-item {
            height: 3rem;

            .info-icon {
                width: 2rem;
                height: 1.5rem;
            }

            .info-value {
                font-size: 1.3rem;
                color: #444;
                margin-left: .5rem;
            }

            .call-btn-item {
                border: 1px solid #6472e7;
                padding: .1rem .4rem;
                margin-left: 1rem;
                border-radius: 0.3rem;
                color: #6472e7;
                font-size: 1rem;
            }
        }
    }
}

.nodata {
    padding: 40px 0;
    font-size: 16px;
    color: #999;
    text-align: center;
}

.comment-box {
    border-top: solid #f8f8f8 10px;
    padding: 15px;

    .tit {
        margin-bottom: 10px;

        span {
            font-size: 16px;
            color: #6472e8;
            font-weight: 500;
            padding-left: 10px;
            line-height: 1;
            border-left: #6472e8 solid 4px;
        }
    }
}

.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    padding: 15px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;

    .btn {
        flex: 1;
        max-width: 48%;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #7181eb;
        border-radius: 20px;
        color: #7181eb;
        box-sizing: border-box;
        margin: 0 10px;

        >img {
            width: 16px;
            height: 16px;
            margin-right: 5px;
        }

        >p {
            font-size: 15px;
        }

        &.btn-cur {
            background: linear-gradient(205deg, #9cb2f4 1%, #9bb1f4 1%, #6472e8 84%);

            p {
                color: #fff;
            }
        }
    }

    .input {
        width: 100%;
        height: 30px;
        border-radius: 20px;
        border: solid #eee 1px;
        padding: 0 10px;
        color: #999;
        font-size: 12px;
        box-sizing: border-box;

        img {
            width: 16px;
            height: 16px;
            margin-right: 5px;
        }

        span {
            font-size: 12px;
            color: #999;
        }
    }
}
</style>